import { render, staticRenderFns } from "./PaymentDetailsForm.vue?vue&type=template&id=95e5f1a6&"
import script from "./PaymentDetailsForm.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports